export default __webpack_public_path__ + "static/media/logoBorealis.76f4da96.svg";